module.exports = {
    APPROVED    : "approved",
    ACTIVE      : "active",
    FAILED      : "failed",
    PENDING     : "pending",
    CLOSED      : "closed",
    DRAFT       : "draft"
};